<template>
  <div id="vessel-tracking-history">
    <div class="centerx history-container">
      <div id="map" class="mb-9"></div>
      <div v-if="data.length > 1 && !hide" class="vx-row h-content">
        <vs-button
          v-if="!playing"
          class="h-btn"
          color="primary"
          type="filled"
          icon="play_arrow"
          @click="onPlay"
        ></vs-button>
        <vs-button v-else class="h-btn" color="primary" type="filled" icon="pause" @click="onPause"></vs-button>
        <vs-button class="h-btn" color="danger" type="filled" icon="stop" @click="onStop"></vs-button>
        <div>
          <vs-slider
            v-model="value"
            :max="data.length - 1"
            color="dark"
            class="h-slider"
            @change="onChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global google*/
import gmapsInit from "@/gmap/gmaps";
import { dateFormat } from "@/utils";
import { mapState } from "vuex";
export default {
  name: "VesselTrackingHistory",
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    hide: {
      type: Boolean,
      default: false
    },
    callback: {
      type: Function,
      default() {}
    },
    dataLatLngHistory: {
      type: Array,
      default() {
        return [];
      }
    },
    vasselReport: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      value: 0,
      google: null,
      tickerTimer: null,
      vessel: null,
      percent: 1,
      zoom: 5,
      milesSea: require("../../milesSea/all.json"),
      playing: false,
      infoWindow: undefined
    };
  },
  computed: {
    ...mapState({
      // data: state => state.vesselHistory.data,
      loading: state => state.vesselHistory.loading
    })
  },
  watch: {
    data(val, oldval) {
      if (val.length != oldval.length) {
        this.initGoogleMap();
        const len = this.data.length - 1;
        this.percent = 100 / len;
      }
    }
  },
  created() {
    if (this.data.length > 0) {
      this.initGoogleMap();
    }
  },
  destroyed() {
    this.onStop();
  },
  mounted() {
    if (this.data.length > 0) {
      const len = this.data.length - 1;
      this.percent = 100 / len;
    }
  },
  methods: {
    async initGoogleMap() {
      this.google = await gmapsInit();
      this.geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(this.data[0].lat, this.data[0].lng);
      var options = {
        zoom: this.zoom,
        center: latlng,
        streetViewControl: false,
        mapTypeControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        fullscreenControl: true,
        gestureHandling: "greedy",
        zoomControl: true
      };
      this.map = new google.maps.Map(this.$el.querySelector("#map"), options);
      this.map.data.addGeoJson(this.milesSea);
      this.map.data.setStyle(function(feature) {
        var color = feature.getProperty("color");
        if (color == "red") {
          color = "red";
        } else if (color == "green") {
          color = "#10FD1E";
        } else if (color == "blue") {
          color = "#00BDFF";
        }
        return {
          fillColor: color,
          strokeWeight: 0
        };
      });
      this.drawPosition();
      this.infoWindow = new google.maps.InfoWindow();

      const markerImage = this.createMarkerIcon(
        this.getVesselImg(this.data[0]),
        50
      );
      this.vessel = this.createVasselMarker(this.data[0], latlng, markerImage);
      this.map.setZoom(15);
    },
    createVasselMarker(data, latlng, img) {
      const vassel = new google.maps.Marker({
        position: latlng,
        map: this.map,
        icon: img,
        zIndex: 999
      });
      const detail = { ...this.vasselReport, ...data };
      const fn1 = this.markerClickFunction1(detail, latlng);
      const fn2 = this.markerClickFunction2(detail, latlng);
      const fn3 = this.markerClickFunction3(detail, latlng);
      google.maps.event.addListener(vassel, "mouseover", fn1);
      google.maps.event.addListener(vassel, "click", fn2);
      google.maps.event.addListener(vassel, "mouseout", fn3);
      return vassel;
    },
    onChange(value) {
      this.moveVessel(value);
      this.callback(value);
    },
    moveVessel(i) {
      const latlng = new google.maps.LatLng(this.data[i].lat, this.data[i].lng);
      // this.vessel.setPosition(latlng);
      this.vessel.setMap(null);
      const markerImage = this.createMarkerIcon(
        this.getVesselImg(this.data[i]),
        50
      );
      this.vessel = this.createVasselMarker(this.data[i], latlng, markerImage);

      this.map.panTo(latlng);
    },
    drawPosition() {
      const coords = [];
      for (let i = 0; i < this.data.length; i++) {
        const icon = this.createMarkerIcon(`/vesselIcon/icons/dot.png`);
        const { position, marker } = this.createMaker(this.data[i], icon);
        const fn1 = this.markerClickFunction1(this.data[i], position);
        const fn2 = this.markerClickFunction2(this.data[i], position);
        const fn3 = this.markerClickFunction3(this.data[i], position);
        google.maps.event.addListener(marker, "mouseover", fn1);
        google.maps.event.addListener(marker, "click", fn2);
        google.maps.event.addListener(marker, "mouseout", fn3);
        coords.push(position);
      }
      this.drawLine(coords);
    },
    createMaker(latlng, markerImage) {
      const position = new google.maps.LatLng(latlng.lat, latlng.lng);
      const marker = new google.maps.Marker({
        position,
        map: this.map,
        icon: markerImage
      });
      return { marker, position };
    },
    drawLine(coords) {
      const line = new google.maps.Polyline({
        path: coords,
        geodesic: true,
        strokeColor: "#000000",
        strokeOpacity: 1.0,
        strokeWeight: 3,
        icons: [
          {
            icon: {
              path: "M-2 -2 L 0 2 L2 -2 Z",
              strokeColor: "#F00",
              fillColor: "#F00",
              fillOpacity: 1,
              strokeWeight: 1
            },
            repeat: "50px"
          }
        ]
      });
      line.setMap(this.map);
    },
    getDirection(direction) {
      const n = direction % 10 ? 0 : 1;
      const tpye = Math.ceil(direction / 10) + n;
      return tpye > 36 ? 10 : tpye;
    },
    getVesselImg(data) {
      const direction = data.true_heading;
      const shipType = "b";
      let iconType = data.icon;
      let imgShip = "other";
      if (iconType == "tanker") {
        imgShip = "tanker";
      } else if (iconType == "other") {
        imgShip = "other";
      } else if (iconType == "passenger") {
        imgShip = "passenger";
      } else if (iconType == "cargo") {
        imgShip = "cargo";
      } else if (iconType == "fishing") {
        imgShip = "fishing";
      } else if (iconType == "EXCISE") {
        imgShip = "excise";
      }
      const imageUrl = `/vesselIcon/${imgShip}/${shipType}${this.getDirection(
        direction
      )}.png`;
      return imageUrl;
    },
    createMarkerIcon(imageUrl, imgSize) {
      const size = imgSize || 8;
      var markerImage = new google.maps.MarkerImage(
        imageUrl,
        new google.maps.Size(size, size),
        new google.maps.Point(0, 0),
        new google.maps.Point(size / 2, size / 2),
        new google.maps.Size(size, size)
      );
      return markerImage;
    },
    clearTickerTimer(isStop) {
      if (this.tickerTimer) {
        clearTimeout(this.tickerTimer);
        this.tickerTimer = null;
        this.playing = false;
        if (isStop) {
          this.value = 0;
        }
      }
    },
    onTickerTimer() {
      const vm = this;
      this.tickerTimer = setTimeout(() => {
        vm.onTickerTimer();
        if (vm.value + 1 <= vm.data.length - 1) {
          vm.value += 1;
        } else if (vm.value + 1 >= vm.data.length - 1) {
          vm.clearTickerTimer(false);
        }
        vm.vessel;
      }, 500);
    },
    onPlay() {
      if (!this.tickerTimer) {
        if (this.value == this.data.length - 1) {
          this.value = 0;
          this.moveVessel(this.value);
        }
        this.playing = true;
        this.onTickerTimer();
      }
    },
    onStop() {
      this.value = 0;
      this.moveVessel(this.value);
      this.clearTickerTimer(true);
    },
    onPause() {
      this.clearTickerTimer(false);
    },
    displayLatlng(latlng) {
      return `${latlng.lat}, ${latlng.lng}`;
    },
    markerClickFunction1(vessel, latlng) {
      return e => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }

        const mmis = vessel.mmsi;
        const mid = vessel.name;
        const lat = vessel.latitude || latlng.lat();
        const lng = vessel.longitude || latlng.lng();
        const speed = vessel.speed_over_ground;
        const hdg_cog = vessel.true_heading || vessel.hdg_cog;
        let record_time = undefined;
        if (vessel.record_time) {
          record_time = dateFormat(vessel.record_time);
        }

        let infoHtml = `<div class="info">`;
        infoHtml += mmis ? `<p> MMIS: ${mmis}` : "";
        infoHtml += mid ? `<br> MID: ${mid}` : "";
        infoHtml += `<p>latitude: ${lat}</p>`;
        infoHtml += `<p>longitude: ${lng}</p>`;
        infoHtml += mid ? `<p> true heading: ${hdg_cog}</p>` : "";
        infoHtml += mid ? `<p> speed over ground: ${speed}</p>` : "";
        infoHtml += record_time ? `<p>record_time: ${record_time}</p>` : "";
        infoHtml += `</div>`;
        this.infoWindow.setContent(infoHtml);
        this.infoWindow.setPosition(latlng);
        this.infoWindow.open(this.map);
      };
    },
    markerClickFunction2(vessel, latLng) {
      return e => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }
        this.vesselData = vessel;
        this.detailVesselStatus = true;
      };
    },
    markerClickFunction3(vessel, latLng) {
      return e => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }
        this.infoWindow.close();
      };
    }
  }
};
</script>
<style scoped>
.history-container {
  margin: 8px;
  padding: 16px;
}
#map {
  padding: 16px;
  position: relative;
  width: 900px;
  height: 400px;
}
.h-height {
  height: 500px;
}
.h-list {
  height: 200px;
}
.h-content {
  padding: 8px;
  align-items: start;
  justify-content: center;
}
.h-ontop {
  align-self: start;
}
.h-btn {
  margin: 4px;
}
.h-slider {
  margin-left: 8px;
}
</style>